import { defineStore } from "pinia";

import { useEntityStore } from "@/shared";

import { deleteSelling } from "../api/deleteSelling";
import { deleteSellings } from "../api/deleteSellings";
import { exportStoreSelling } from "../api/exportStoreSelling";
import { getStoreSellings } from "../api/getStoreSellings";

export const useStoreSellingsStore = defineStore("storeSellings", () => {
    const {
        isManyLoading,
        manyError,
        listData,
        meta,
        permissions,
        fetchMany,
        deleteOne,
        deleteMany,
        exportMany,
        setManyLoading,
    } = useEntityStore({
        getEntities: getStoreSellings,
        deleteEntity: deleteSelling,
        deleteEntities: deleteSellings,
        exportEntities: exportStoreSelling,
    });

    return {
        listData,
        isManyLoading,
        manyError,
        meta,
        permissions,
        fetchMany,
        deleteOne,
        deleteMany,
        exportMany,
        setManyLoading,
    };
});
